<div class="customs-select">
    <!-- <label>Module</label> -->
    <mat-form-field>
        <!-- <mat-label *ngIf="field.label">{{ field.label }}</mat-label> <span class="required" *ngIf="field.required"> *</span> -->
        <mat-select [value]="value" [disabled]="disabled" [multiple]="multiple || !!field?.multiple"
            [placeholder]="field?.placeholder || 'Select'" (selectionChange)="onChange($event.value)"
            (blur)="onTouched()">
            <mat-option *ngFor="let option of field.options" [value]="option.value">
                {{ option.label }}
            </mat-option>
        </mat-select>
        <small class="error" *ngIf="errorMessage">
            {{ errorMessage }}
        </small>
    </mat-form-field>
</div>